import { render } from "./cuentabancaria.vue?vue&type=template&id=5e111576&scoped=true"
import script from "./cuentabancaria.vue?vue&type=script&lang=js"
export * from "./cuentabancaria.vue?vue&type=script&lang=js"

import "./cuentabancaria.vue?vue&type=style&index=0&id=5e111576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e111576"]])

export default __exports__